import { Input, HostBinding, Directive } from '@angular/core'
import { GaugeComponentViewbox } from '../gauge-component-viewbox'

/**
 * @internal
 */
@Directive({
  selector: 'text[gpeiGaugeLabel]',
  standalone: true
})
export class GaugeLabelDirective {

  /**
   * The angle on the gauge that the label will appear at
   */
  @Input() angle: number

  /**
   * Determine the distance between the label and the center of the gauge
   */
  @Input() radius: number

  /**
   * The class attribute of the host element
   *
   * @privateRemarks
   *
   * It should be noted that if your component has a selector of an SVG Element
   * it must use `attr.class` instead of `class`, as there is no setter for
   * className on SVG Elements
   */
  @HostBinding('attr.class')
  private _hostClass = 'gauge-label'

  /**
   * Generate a transform CSS property that will rotate and position a label
   * onto a position of the gauge
   */
  @HostBinding('style.transform')
  private get _hostStyle(): string {
    return `translate(${ GaugeComponentViewbox.CENTER }px, ${ GaugeComponentViewbox.CENTER }px) rotate(${ this.angle }deg) translateY(-${ this.radius }px)`
  }

}
